import React from 'react';
import './PlayerSupport.css';

const PlayerSupport = () => {
    return (
        <main className='main'>
            <section className='section player-support-section'>
                <div className="player-support-container container">
                    <header className="player-support-header">
                        <h1 className="section-title">Player Support Services</h1>
                        <p className="player-support-subtitle">
                            File a dispute with a licensee, seek assistance with self-exclusion across all licensee
                            sites, learn more about responsible gaming.
                        </p>
                    </header>

                    <section className="player-support-intro">
                        <p>
                            Welcome to Anjouan Gaming’s Player Support page. At Anjouan Gaming, we are committed to
                            ensuring a safe, fair, and transparent online gaming environment. As the official regulatory
                            authority for Internet Gaming Licenses on the Autonomous Island of Anjouan, we strive to
                            protect players’ rights and promote responsible gaming practices. Below, you’ll find
                            information about the support services we offer to help you address any concerns or disputes
                            you may encounter.
                        </p>
                    </section>

                    <section className="player-support-services">
                        <h2 className="player-support-section-title">Support Services</h2>

                        <article className="player-support-article">
                            <h3 className="player-support-article-title">1. Dispute Resolution</h3>
                            <p>
                                If you have a dispute with a licensed online casino or betting site that holds a valid
                                Anjouan Gaming License, we’re here to help. Our Player Support team can act as a neutral
                                third-party, assessing disputes related to account management, game fairness, and other
                                service concerns.
                            </p>
                            <p>To initiate the dispute resolution process, please follow these steps:</p>
                            <ol>
                                <li>
                                    Submit the dispute to the relevant operator via the “Submit a Complaint” form in the
                                    site seal, and allow them the opportunity to resolve the issue.
                                </li>
                                <li>
                                    If you are unsatisfied with the operator’s response, the dispute may be escalated to
                                    Anjouan Gaming for review and consideration.
                                </li>
                                <li>
                                    Our team will carefully review the information provided and work towards a fair
                                    outcome. Please note that the decision by Anjouan Gaming is final and binding.
                                </li>
                            </ol>
                        </article>

                        <article className="player-support-article">
                            <h3 className="player-support-article-title">2. Responsible Gaming Support</h3>
                            <p>
                                Anjouan Gaming supports responsible gaming and is dedicated to protecting players from
                                problem gambling. If you or someone you know needs assistance, our Player Support page
                                provides resources and information to help you stay in control.
                            </p>
                            <p>Key responsible gaming services include:</p>
                            <ul>
                                <li><strong>Self-Exclusion:</strong> Players can request self-exclusion from licensed
                                    operators to limit access to gaming services via the relevant operator’s site seal.
                                </li>
                                <li><strong>Time and Spending Limits:</strong> We encourage licensed operators to
                                    provide options for players to set personal limits on deposits, wagers, and gaming
                                    time.
                                </li>
                                <li><strong>Referral to Support Organizations:</strong> We can guide you to reputable
                                    organizations offering help and support for responsible gaming.
                                </li>
                            </ul>
                            <p>
                                For self-exclusion requests, please use the relevant self-exclusion form on the
                                operator’s site seal.
                            </p>
                        </article>

                        <article className="player-support-article">
                            <h3 className="player-support-article-title">3. License Verification</h3>
                            <p>
                                To ensure transparency and player safety, we provide a public register where players can
                                verify the license status of any online gaming operator licensed by Anjouan Gaming. You
                                can access the register here:&nbsp;
                                <a
                                    href="https://anjouangaming.com/license-register/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    https://anjouangaming.com/license-register/
                                </a>
                            </p>
                            <p>
                                This register allows you to confirm that you are playing on a reputable and regulated
                                site, giving you peace of mind regarding security, fairness, and compliance. If the site
                                does not appear in our public register, then it is not licensed and supervised by
                                Anjouan Gaming.
                            </p>
                        </article>

                        <article className="player-support-article">
                            <h3 className="player-support-article-title">4. Reporting Concerns</h3>
                            <p>
                                If you come across any non-compliance by an Anjouan-licensed operator, please notify us.
                                Our Compliance Team will review the report and take appropriate action to safeguard the
                                integrity of the online gaming ecosystem.
                            </p>
                            <p>
                                To report a concern, contact us directly at&nbsp;
                                <a href="mailto:admin@anjouangaming.com" className='href'>admin@anjouangaming.com</a>
                                &nbsp;with detailed information.
                            </p>
                        </article>
                    </section>
                </div>
            </section>
        </main>
    );
};

export default PlayerSupport;